import React from 'react';
import { OutlinedInput } from '@mui/material';
import PropTypes from 'prop-types';

export default function InputSimple(props) {
  const { children } = props;

  return <OutlinedInput {...props}>{children}</OutlinedInput>;
}

InputSimple.propTypes = {
  children: PropTypes.node.isRequired,
};
